module.exports = __webpack_public_path__ + "static/media/CrimsonText-Bold.89b16aa6.ttf";